define('Magento_LayeredNavigation/js/filter-state',[
    "jquery",
], function ($) {
    "use strict";

    $.widget('decimaDigital.filterState', {
        options: {
            filter: '.filter-content .item a',
            checkbox: '.amshopby-link-selected input'
        },
        _create: function () {
            var $widget = this;

            $($widget.options.checkbox).attr('checked', 'checked');

            $($widget.options.filter).on('click', function (event) {
                $(event.target).parent().find('input').attr('checked', 'checked');
            });
        }
    });

    return $.decimaDigital.filterState;
});

